import { render, staticRenderFns } from "./IndexV2.vue?vue&type=template&id=f90d5886&scoped=true&"
import script from "./IndexV2.vue?vue&type=script&lang=js&"
export * from "./IndexV2.vue?vue&type=script&lang=js&"
import style0 from "./IndexV2.vue?vue&type=style&index=0&id=f90d5886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90d5886",
  null
  
)

export default component.exports